// GLOBAL CONFIG SETTINGS

// VUE CONFIG
// =================================================================================================

/**
 * Vue has the same tag delimiters as Twig: {{ }}. This causes template rendering errors when
 * using Vue in Twig templates. Vue's default delimiters can remain for Vue components, but use
 * square brackets instead for Twig templates.
 *
 * @type {string[]}
 */
export const VUE_INSTANCE_DELIMITERS = ['[[', ']]'];


// ENVIRONMENTS
// =================================================================================================
/** @type {string} **/
export const LOCAL_ENVIRONMENT = 'local';
/** @type {string} */
export const DEVELOPMENT_ENVIRONMENT = 'development';
/** @type {string} */
export const STAGING_ENVIRONMENT = 'staging';
/** @type {string} */
export const PRODUCTION_ENVIRONMENT = 'production';

/**
 * Is this a developer's local environment?
 *
 * @return {boolean}
 */
export const isLocalEnv = () => {
   try {
      return window.mymy.request.craftEnv === LOCAL_ENVIRONMENT;
   }
   catch (e) {
      if(window.Sentry) {
         Sentry.captureException(e);
      }
      console.error(e);
      return false;
   }
};

/**
 * Is this our remote "Dev" server environment?
 *
 * @return {boolean}
 */
export const isDevelopmentEnv = () => {
   try {
      return window.mymy.request.craftEnv === DEVELOPMENT_ENVIRONMENT;
   }
   catch (e) {
      if(window.Sentry) {
         Sentry.captureException(e);
      }
      console.error(e);
      return false;
   }
};

/**
 * Is this our remote "Staging" server environment?
 *
 * @return {boolean}
 */
export const isStagingEnv = () => {
   try {
      return window.mymy.request.craftEnv === STAGING_ENVIRONMENT;
   }
   catch (e) {
      if(window.Sentry) {
         Sentry.captureException(e);
      }
      console.error(e);
      return false;
   }
};

/**
 * Is this our remote "Production" server environment (the live site)?
 *
 * @return {boolean}
 */
export const isProductionEnv = () => {
   try {
      return window.mymy.request.craftEnv === PRODUCTION_ENVIRONMENT;
   }
   catch (e) {
      if(window.Sentry) {
         Sentry.captureException(e);
      }
      console.error(e);
      return false;
   }
};

/**
 * Can this environment view test code developers output to the console?
 *
 * @return {boolean}
 */
export const canViewTestCode = () => {
   try {
      return [LOCAL_ENVIRONMENT, DEVELOPMENT_ENVIRONMENT, STAGING_ENVIRONMENT].includes(window.mymy.request.craftEnv);
   }
   catch (e) {
      if(window.Sentry) {
         Sentry.captureException(e);
      }
      console.error(e);
      return false;
   }
};


// CRAFT ENTRIES
// =================================================================================================

/**
 * The entry type for "allergen" entries in the "Allergens And Dietary Preferences" channel.
 *
 * @type {string}
 * @see http://localhost:8000/mymycms/settings/sections/39/entrytypes
 */
export const ALLERGEN_ENTRY_TYPE_HANDLE = 'allergen';

/**
 * The entry type for "dietary preferences" entries in the "Allergens And Dietary Preferences"
 * channel.
 *
 * @type {string}
 * @see http://localhost:8000/mymycms/settings/sections/39/entrytypes
 */
export const DIETARY_PREFERENCE_ENTRY_TYPE_HANDLE = 'dietaryPreference';


// CRAFT CUSTOM FIELDS
// =================================================================================================

/**
 * The "Number of People" custom field handle.
 *
 * @type {string}
 * @see http://localhost:8000/mymycms/settings/fields/edit/139
 */
export const CUSTOM_FIELD_HANDLE_NUMBER_OF_PEOPLE = 'numberOfPeople';

/**
 * The "Delivery Date" custom field handle.
 *
 * @type {string}
 * @see http://localhost:8000/mymycms/settings/fields/edit/132
 */
export const CUSTOM_FIELD_HANDLE_DELIVERY_DATE = 'deliveryDate';